// import foo from './foo';

const root = {
	//	foo
};

export default root;
